module.exports = __webpack_public_path__ + "static/media/css.9b9bce90.png";